import { useLayoutEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { api } from 'api';
import { AuthenticationQueryKey } from 'features/authentication';

export function useSessionResetOn503() {
  const queryClient = useQueryClient();

  useLayoutEffect(() => {
    const interceptor = api.global.addResponseErrorInterceptor(async (error) => {
      if (
        api.global.isRequestError(error) &&
        error.response?.status === 503 &&
        !error.config?.url?.startsWith('/auth/session')
      ) {
        await queryClient.resetQueries([AuthenticationQueryKey.CheckSession]);
        api.global.removeDebugToken();
      }
      return Promise.reject(error);
    });

    return () => {
      api.global.removeResponseInterceptor(interceptor);
    };
  }, [queryClient]);
}
